/*
* Mobile menue
*/
function mobileMenu() {
    document.addEventListener('DOMContentLoaded', () => {
        const metaNav = document.getElementById('meta-nav');
        const mainNav = document.getElementById('navbarNavDropdown');
        const offcanvasBody = document.querySelector('.offcanvas-body');
        // Keep reference to SlideMenu instance to properly destroy on desktop reset
        let __slideMenuInstance = null;

        //Mobile menue: Activate mobile menu
        function activateMobileMenu() {
            const menuRightElem = document.getElementById('navbarNavDropdown');
            // Recreate SlideMenu fresh (destroy any previous instance first)
            try {
                if (__slideMenuInstance && typeof __slideMenuInstance.destroy === 'function') {
                    __slideMenuInstance.destroy();
                }
            } catch (e) { /* noop */ }

            __slideMenuInstance = new SlideMenu(menuRightElem, {
                // https://github.com/grubersjoe/slide-menu
                showBackLink: true
            });
            removeBackButton()
        }

        function enquireWindow() {
            // store original classes to be able to reset without reload
            const originalMainNavClass = mainNav ? mainNav.className : '';

            function resetMobileMenu() {
                if (!mainNav) return;

                // Properly destroy SlideMenu to remove all its event listeners
                try {
                    if (__slideMenuInstance && typeof __slideMenuInstance.destroy === 'function') {
                        __slideMenuInstance.destroy();
                    }
                } catch (e) { /* ignore */ }
                __slideMenuInstance = null;

                // Restore original classes on the main nav
                if (originalMainNavClass) {
                    mainNav.className = originalMainNavClass; // expected: "collapse navbar-collapse"
                } else {
                    mainNav.classList.remove('slide-menu');
                }

                // Remove inline styles left by mobile menu
                mainNav.removeAttribute('style');

                // Ensure the desktop backdrop is hidden
                const desktopBackdrop = document.querySelector('.main-menu-backdrop');
                if (desktopBackdrop) desktopBackdrop.classList.remove('show');

                // Close/reset Bootstrap Offcanvas if it is open
                const offcanvasEl = document.getElementById('offcanvas-mainnav');
                if (offcanvasEl) {
                    try {
                        const Offcanvas = window.bootstrap && window.bootstrap.Offcanvas;
                        if (Offcanvas && typeof Offcanvas.getInstance === 'function') {
                            const instance = Offcanvas.getInstance(offcanvasEl) || new Offcanvas(offcanvasEl);
                            if (instance) instance.hide();
                        }
                    } catch (e) {
                        // ignore if bootstrap not available
                    }
                    offcanvasEl.classList.remove('show');
                    offcanvasEl.removeAttribute('style');
                    offcanvasEl.removeAttribute('aria-modal');
                    offcanvasEl.removeAttribute('role');
                    offcanvasEl.setAttribute('aria-hidden', 'true');
                }
                // Remove any offcanvas backdrop artifacts and body locks
                document.querySelectorAll('.offcanvas-backdrop').forEach((el) => el.remove());
                document.body.classList.remove('offcanvas-open');
                document.body.style.overflow = '';

                // If SlideMenu wrapped the list into slider containers, unwrap it
                const mainMenu = mainNav.querySelector('#main-menu');
                if (mainMenu) {
                    // Ensure the top-level UL has only the bootstrap class
                    mainMenu.classList.remove('dropdown-menu');
                    if (!mainMenu.classList.contains('navbar-nav')) {
                        mainMenu.classList.add('navbar-nav');
                    }

                    // Move the main menu directly under the navbar container
                    if (mainMenu.parentElement && mainMenu.parentElement !== mainNav) {
                        mainNav.appendChild(mainMenu);
                    }
                }
                // Remove any slider wrappers completely
                mainNav.querySelectorAll('.slide-menu__slider').forEach((el) => el.remove());

                // Re-add Bootstrap dropdown classes only to submenus (not the top-level #main-menu)
                mainNav.querySelectorAll('#main-menu ul').forEach((ul) => {
                    ul.classList.add('dropdown-menu');
                });

                // Re-apply level classes based on nesting depth
                mainNav.querySelectorAll('#main-menu > li > ul').forEach((ul) => {
                    ul.classList.add('level-1');
                });
                mainNav.querySelectorAll('#main-menu > li > ul > li > ul').forEach((ul) => {
                    ul.classList.add('level-2');
                });

                // Remove helper/back links added in mobile mode FIRST, before we strip classes
                // so that selectors like a.slide-menu__backlink still match.
                mainNav.querySelectorAll('li.parent-category-link, li.submenu-focus-sentinel').forEach((li) => li.remove());
                // Remove only the backlink helper <li> items (do NOT remove their parent menu items)
                mainNav.querySelectorAll('a.slide-menu__backlink').forEach((a) => {
                    if (a && a.parentElement && a.parentElement.tagName === 'LI') {
                        a.parentElement.remove();
                    }
                });

                // Clean up any mobile slide-menu classes on existing elements
                mainNav.querySelectorAll('#main-menu .slide-menu__submenu, #main-menu .slide-menu__level, #main-menu .slide-menu__item').forEach((el) => {
                    el.classList.remove('slide-menu__submenu', 'slide-menu__level', 'slide-menu__item', 'slide-menu__submenu--active');
                });
                // Remove any class starting with slide-menu__
                mainNav.querySelectorAll('#main-menu *').forEach((el) => {
                    if (el.classList && el.classList.length) {
                        Array.from(el.classList)
                            .filter((c) => c.indexOf('slide-menu__') === 0)
                            .forEach((c) => el.classList.remove(c));
                    }
                });
                // Remove inline styles (like display:block) enforced in mobile state for level-1 flyouts
                mainNav.querySelectorAll('#main-menu ul.level-1, #main-menu .flyout > ul').forEach((ul) => {
                    ul.removeAttribute('style');
                    ul.classList.remove('slide-menu__submenu--active', 'has-wrap', 'no-wrap');
                });
                // Ensure no dropdowns are forcibly shown and toggles have correct aria state
                mainNav.querySelectorAll('.dropdown-menu.show').forEach((el) => el.classList.remove('show'));
                mainNav.querySelectorAll('.dropdown.show').forEach((el) => el.classList.remove('show'));
                mainNav.querySelectorAll('.dropdown-toggle[aria-expanded="true"]').forEach((a) => a.setAttribute('aria-expanded', 'false'));

                // As an additional safety net, purge any residual third-party listeners by cloning anchors
                // (only if SlideMenu did not expose a destroy method or failed to unbind)
                mainNav.querySelectorAll('#main-menu a').forEach((a) => {
                    if (!a) return;
                    // Skip if already clean (no inline listeners) – but cloning is inexpensive
                    const clone = a.cloneNode(true);
                    // Preserve dataset attributes used by Bootstrap/toggling
                    a.parentNode && a.parentNode.replaceChild(clone, a);
                });

                // SAFEGUARD: In case classes were already stripped before this ran, remove any orphaned
                // backlink list items that contain a single anchor with no Bootstrap menu classes.
                mainNav.querySelectorAll('#main-menu ul li').forEach((li) => {
                    if (li.children && li.children.length === 1 && li.firstElementChild && li.firstElementChild.tagName === 'A') {
                        const a = li.firstElementChild;
                        const aClass = (a.getAttribute('class') || '').trim();
                        const isMenuAnchor = a.classList.contains('dropdown-item') || a.classList.contains('nav-link');
                        // Backlinks typically have no href or href="#" and no menu classes
                        const href = a.getAttribute('href');
                        const looksLikeBacklink = (!href || href === '#') && !isMenuAnchor && aClass === '';
                        if (looksLikeBacklink) {
                            li.remove();
                        }
                    }
                });

                // Reset meta/back button visibility
                const backButton = document.querySelector('#backbutton');
                const metaNavEl = document.getElementById('meta-nav');
                if (backButton) backButton.style.display = 'none';
                if (metaNavEl) metaNavEl.style.display = '';
            }

            enquire.register('screen and (max-width: 889px)', {
                match: function () {
                    // Move metanav to offcanvas menu
                    // offcanvasBody.appendChild(metaNav);
                    // Mobile menu: Remove classes from boostrap desktop menue
                    mainNav.className = "slide-menu";
                    mainNav.querySelectorAll("ul").forEach((ul) => {
                        ul.classList.remove("dropdown-menu");
                    });
                    addParentCategoryLinkAboveMenu();
                    activateMobileMenu();
                }, unmatch: function () {
                    // Reset all classes and elements for desktop view (no reload)
                    resetMobileMenu();
                }
            })
            enquire.register('screen and (min-width: 890px)', {
                match: function () {
                    // Desktop menu: Call function for hover animation on desktop
                    desktopMenuHoverAnimation();
                    // Desktop menu: keyboard accessible flyout (Enter/Space/Escape)
                    desktopMenuKeyboard();
                }
            })
        }
        enquireWindow();
    })
}
mobileMenu();

/*
* Mobile menue: Remove back button if first level is shown in navigation
*/
function removeBackButton() {
    const backButton = document.querySelector('#backbutton');
    const slider = document.querySelector('.slide-menu__slider');
    const metaNav = document.getElementById('meta-nav');

    // Show and hide back button after navigate. Inital it has 'display:none' as inline style in php
    if (slider && backButton) {
        slider.addEventListener('transitionend', () => {
            if (slider.style.transform.includes('translateX(0%)')) {
                backButton.style.display = 'none';
                metaNav.style.display = 'block';
            } else {
                backButton.style.display = 'block';
                metaNav.style.display = 'none';
            }
        });
    }
    // Remove slide back functionality from back link. We only need it as headline.
    document.querySelectorAll('a.slide-menu__backlink').forEach(function (element) {
        element.removeAttribute('data-action');
    });

}


/*
* Desktop: Mega menu flyout animation with backdrop
*/
function desktopMenuHoverAnimation() {
    document.querySelectorAll('#main-menu > li.dropdown').forEach((li) => {
        li.addEventListener('mouseover', () => {
            document.querySelector('.main-menu-backdrop').classList.add('show');
            // Compute alignment class as early as possible on hover
            const level1 = li.querySelector('ul.dropdown-menu.level-1');
            adjustLevel1Justify(level1);
        });
        li.addEventListener('touchstart', () => {
            document.querySelector('.main-menu-backdrop').classList.add('show');
            const level1 = li.querySelector('ul.dropdown-menu.level-1');
            adjustLevel1Justify(level1);
        });
        li.addEventListener('mouseout', () => {
            document.querySelector('.main-menu-backdrop').classList.remove('show');
        });
    });
}


/*
* Desktop: Keyboard accessible mega menu (disclosure pattern).
* The flyout must NOT open on focus alone (that forces users to tab through the
* whole submenu to reach the next top-level item). Instead Enter/Space toggles
* it open, Escape closes it, and tabbing out of the item closes it. The open
* state reuses the exact same CSS as :hover via the .flyout-open class.
*/
function desktopMenuKeyboard() {
    const backdrop = document.querySelector('.main-menu-backdrop');

    function anyOpen() {
        return document.querySelector('#main-menu > li.dropdown.flyout-open');
    }

    function closeItem(li) {
        li.classList.remove('flyout-open');
        const toggle = li.querySelector(':scope > a.dropdown-toggle');
        if (toggle) toggle.setAttribute('aria-expanded', 'false');
        if (backdrop && !anyOpen()) backdrop.classList.remove('show');
    }

    function openItem(li, toggle) {
        // Only one top-level flyout open at a time.
        document.querySelectorAll('#main-menu > li.dropdown.flyout-open').forEach((other) => {
            if (other !== li) closeItem(other);
        });
        li.classList.add('flyout-open');
        toggle.setAttribute('aria-expanded', 'true');
        if (backdrop) backdrop.classList.add('show');
        adjustLevel1Justify(li.querySelector('ul.dropdown-menu.level-1'));
    }

    document.querySelectorAll('#main-menu > li.dropdown').forEach((li) => {
        const toggle = li.querySelector(':scope > a.dropdown-toggle');
        if (!toggle || toggle.dataset.kbBound) return;
        toggle.dataset.kbBound = '1';

        toggle.addEventListener('keydown', (event) => {
            if (event.key === 'Enter' || event.key === ' ' || event.key === 'Spacebar') {
                // These parent links are menu headlines; open the flyout instead of navigating.
                event.preventDefault();
                if (li.classList.contains('flyout-open')) {
                    closeItem(li);
                } else {
                    openItem(li, toggle);
                }
            } else if (event.key === 'Escape' && li.classList.contains('flyout-open')) {
                closeItem(li);
                toggle.focus();
            }
        });

        // Close when focus leaves the whole item (e.g. tabbing to the next top-level item).
        li.addEventListener('focusout', (event) => {
            if (!li.contains(event.relatedTarget)) {
                closeItem(li);
            }
        });
    });
}


function primeLogo() {
    const primeState = document.getElementById('prime-state');
    if (primeState) {
        // The prime logo belongs to the intro/hero block, which is always the first
        // top-level block in `#content` (prime-logo.php only runs on the homepage
        // template). Anchoring on the first block - rather than a specific class like
        // `intro-wp-block-media-text`, which not every carousel carries - lets it work
        // for a media-text hero as well as any carousel/slider hero. We must NOT search
        // the whole page for `.wp-block-media-text__media`: other blocks (e.g. the CTA
        // contact block) also contain that element and would otherwise steal the logo.
        const intro = document.querySelector('#content > div');

        // Desktop target: the carousel is itself the media element, otherwise it's the
        // media figure nested inside the media-text block.
        const mediaElement = intro
            ? (intro.matches('.carousel') ? intro : (intro.querySelector('.carousel') || intro.querySelector('.wp-block-media-text__media')))
            : null;

        if (!intro) {
            return;
        }

        enquire.register('screen and (min-width: 992px)', {
            match: function () {
                if (mediaElement) {
                    mediaElement.appendChild(primeState);
                }
            }, unmatch: function () {

            }
        })
        enquire.register('screen and (max-width: 991px)', {
            match: function () {
                intro.parentNode.insertBefore(primeState, intro.nextSibling);
            }, unmatch: function () {

            }
        })
    }
}

primeLogo()


// Preparation for tooltips. Works only with jQuery?
// function setTooltips() {
//     jQuery(function () {
//         jQuery('[data-toggle="tooltip"]').tooltip()
//     })
// }
// setTooltips();


function tabs() {
// I got help from the origin plugin developer regarding not working tabs.
// https://wordpress.org/support/topic/block-tabs-doesnt-work-as-expected/#post-18240753
// https://youtrack.iwelt.de/issue/WMR24-148/Content-Element-Tabs
//
// Barrierefreiheit: Die Tabs sind nach dem WAI-ARIA "Tabs"-Pattern ausgezeichnet
// (role=tablist/tab/tabpanel, aria-selected, aria-controls/aria-labelledby,
// roving tabindex + Pfeiltasten-/Home-/End-Steuerung). Dadurch erkennen Screenreader
// die per d-none ausgeblendeten Panels als zusammenhaengende Tab-Gruppe und koennen
// sie gezielt ansteuern, statt dass der Inhalt "versteckt" bleibt.
// Die Funktion steuert Sichtbarkeit (d-none) weiterhin selbst und ist damit unabhaengig
// vom parallel geladenen Plugin-Handler (bootstrap-extra.js) lauffaehig.

    jQuery(document).ready(function ($) {
        $('.areoi-tabs').each(function (tabsIndex) {
            var $container = $(this);
            var $tablist = $container.find('.nav').first();
            var $tabs = $tablist.find('a');

            if (!$tabs.length) {
                return;
            }

            // Panel per Tab-href auffinden (Attribut-Selektor vermeidet Escaping-Probleme bei IDs).
            function panelFor($tab) {
                var href = $tab.attr('href') || '';
                if (href.charAt(0) !== '#') {
                    return $();
                }
                return $container.find('> div[id="' + href.slice(1) + '"]');
            }

            $tablist.attr('role', 'tablist');
            $container.find('> div').addClass('tab-pane');

            // Aktiven Tab bestimmen: erster mit .active, sonst erster Tab.
            var $active = $tabs.filter('.active').first();
            if (!$active.length) {
                $active = $tabs.first();
            }
            $tabs.not($active).removeClass('active');
            $active.addClass('active');

            // Tabs und Panels verknuepfen und ARIA-Grundzustand setzen.
            $tabs.each(function (i) {
                var $tab = $(this);
                var $panel = panelFor($tab);
                var isActive = $tab.is($active);

                // Der Tab braucht eine ID, damit das Panel via aria-labelledby darauf zeigen kann.
                var tabId = $tab.attr('id');
                if (!tabId) {
                    var base = $panel.length ? $panel.attr('id') : ('areoi-tab-' + tabsIndex + '-' + i);
                    tabId = base + '-tab';
                    $tab.attr('id', tabId);
                }

                $tab.attr({
                    'role': 'tab',
                    'aria-selected': isActive ? 'true' : 'false',
                    'tabindex': isActive ? '0' : '-1'
                });

                if ($panel.length) {
                    $tab.attr('aria-controls', $panel.attr('id'));

                    var panelAttrs = {
                        'role': 'tabpanel',
                        'aria-labelledby': tabId
                    };
                    // tabindex nur, wenn das Panel selbst keine fokussierbaren Elemente enthaelt (APG-Empfehlung).
                    if (!$panel.find('a[href], button, input, select, textarea, [tabindex]').length) {
                        panelAttrs.tabindex = '0';
                    }
                    $panel.attr(panelAttrs);

                    $panel.toggleClass('d-none', !isActive);
                    if (isActive) {
                        $panel.removeAttr('hidden');
                    } else {
                        $panel.attr('hidden', 'hidden');
                    }
                }
            });

            function activate($tab, setFocus) {
                if (!$tab || !$tab.length) {
                    return;
                }
                var $panel = panelFor($tab);

                $tabs.removeClass('active').attr({ 'aria-selected': 'false', 'tabindex': '-1' });
                $container.find('> div.tab-pane').addClass('d-none').attr('hidden', 'hidden');

                $tab.addClass('active').attr({ 'aria-selected': 'true', 'tabindex': '0' });

                if ($panel.length) {
                    $panel.removeClass('d-none').removeAttr('hidden');
                }

                if (setFocus) {
                    $tab.trigger('focus');
                }
            }

            $tablist.on('click', 'a', function (e) {
                var href = $(this).attr('href');
                if (href && href.charAt(0) === '#') {
                    e.preventDefault();
                    activate($(this), false);
                }
            });

            // Tastatursteuerung nach WAI-ARIA Tabs (automatische Aktivierung beim Fokuswechsel).
            $tablist.on('keydown', 'a', function (e) {
                var idx = $tabs.index(this);
                var newIdx = null;

                switch (e.key) {
                    case 'ArrowRight':
                    case 'ArrowDown':
                        newIdx = (idx + 1) % $tabs.length;
                        break;
                    case 'ArrowLeft':
                    case 'ArrowUp':
                        newIdx = (idx - 1 + $tabs.length) % $tabs.length;
                        break;
                    case 'Home':
                        newIdx = 0;
                        break;
                    case 'End':
                        newIdx = $tabs.length - 1;
                        break;
                    case 'Enter':
                    case ' ':
                    case 'Spacebar':
                        e.preventDefault();
                        activate($(this), false);
                        return;
                    default:
                        return;
                }

                e.preventDefault();
                activate($tabs.eq(newIdx), true);
            });
        });
    });
}

tabs()

// Headline pages have no valid href, these are custom links in menu.
// But I think it's better to deactivate the behaviour additionally.
// Especially since this was already finished before the menu pages were redesigned ;)

function unlinkFlyoutMenuHeaders() {
    document.querySelectorAll('.level-1 > li.menu-item-has-children > a').forEach(link => {
        link.addEventListener('click', event => {
            event.preventDefault();
        });
    });
}

// unlinkFlyoutMenuHeaders()


function addParentCategoryLinkAboveMenu() {
    document.querySelectorAll('.menu-item-has-children > a').forEach(function (link) {
        // Clone the link
        const clonedLink = link.cloneNode(true);

        // Create a text node with "gehe zu"
        const textNode = document.createTextNode('Zur Seite ');

        // Prepend the text node to the cloned link
        clonedLink.insertBefore(textNode, clonedLink.firstChild);

        // Find the target submenu UL:
        // - level-2: directly a UL after the link
        // - level-1: a DIV.flyout wrapper after the link that contains the UL
        let targetUl = null;
        const nextEl = link.nextElementSibling;
        if (nextEl && nextEl.tagName === 'UL') {
            targetUl = nextEl;
        } else if (nextEl && nextEl.classList && nextEl.classList.contains('flyout')) {
            targetUl = nextEl.querySelector('ul');
        }

        if (targetUl && targetUl.tagName === 'UL') {
            // Duplication guards: if already added, do nothing
            const alreadyHasParentLink = !!targetUl.querySelector(':scope > li.parent-category-link');
            const alreadyHasSentinel = !!targetUl.querySelector(':scope > li.submenu-focus-sentinel');
            if (alreadyHasParentLink && alreadyHasSentinel) return;

            // Create helper items if missing
            let sentinelLi = targetUl.querySelector(':scope > li.submenu-focus-sentinel');
            if (!sentinelLi) {
                sentinelLi = document.createElement('li');
                sentinelLi.className = 'submenu-focus-sentinel';
                sentinelLi.setAttribute('tabindex', '-1'); // not in tab order
            }

            let parentLinkLi = targetUl.querySelector(':scope > li.parent-category-link');
            if (!parentLinkLi) {
                parentLinkLi = document.createElement('li');
                parentLinkLi.className = 'parent-category-link';
                parentLinkLi.appendChild(clonedLink);
            }

            // Insert in correct order: sentinel first, then parent link
            // Use insertBefore to place at the very beginning
            targetUl.insertBefore(parentLinkLi, targetUl.firstChild);
            targetUl.insertBefore(sentinelLi, targetUl.firstChild);
        }
    });
}

/*
* Desktop mega menu: Precompute wrapping for level-1 flyouts and toggle CSS classes
* If items wrap to a new line -> add class 'has-wrap' (justify-content:flex-start)
* else add class 'no-wrap' (justify-content:space-between)
*/
function adjustLevel1Justify(level1) {
    if (!level1) return;
    if (!isDesktopViewport()) {
        // On mobile we don't maintain desktop alignment classes
        level1.classList.remove('has-wrap', 'no-wrap');
        return;
    }

    const width = getAvailableMenuWidth(level1);
    const wrapped = measureWrapForLevel1(level1, width);
    level1.classList.toggle('has-wrap', wrapped);
    level1.classList.toggle('no-wrap', !wrapped);
}

function adjustAllVisibleLevel1() {
    const isDesktop = isDesktopViewport();
    document.querySelectorAll('ul.dropdown-menu.level-1').forEach((ul) => {
        if (!isDesktop) {
            ul.classList.remove('has-wrap', 'no-wrap');
            return;
        }
        adjustLevel1Justify(ul);
    });
}

// Helper: estimate available width for the menu when visible
function getAvailableMenuWidth(level1) {
    // Prefer the actual flyout container width if present
    const flyout = level1.closest('.flyout');
    if (flyout) {
        const r = flyout.getBoundingClientRect();
        if (r && r.width) return Math.max(0, Math.floor(r.width));
    }

    // Then prefer the main nav container width (container or container-fluid)
    const navContainer = document.querySelector('#main-nav > .container, #main-nav > .container-fluid');
    if (navContainer) {
        const r = navContainer.getBoundingClientRect();
        if (r && r.width) return Math.max(0, Math.floor(r.width));
    }

    // Fallback to navbar content wrapper
    const nav = document.getElementById('navbarNavDropdown');
    if (nav) {
        const r = nav.getBoundingClientRect();
        if (r && r.width) return Math.max(0, Math.floor(r.width));
    }

    // Last resort: viewport width
    return Math.max(0, Math.floor(window.innerWidth || 0));
}

// Helper: measure wrapping off-DOM to avoid flicker
function measureWrapForLevel1(level1, availableWidth) {
    const clone = level1.cloneNode(true);
    clone.style.position = 'absolute';
    clone.style.left = '-99999px';
    clone.style.top = '0';
    clone.style.visibility = 'hidden';
    clone.style.pointerEvents = 'none';
    clone.style.display = 'flex';
    clone.style.flexWrap = getComputedStyle(level1).flexWrap || 'wrap';
    clone.style.width = availableWidth + 'px';
    clone.classList.remove('has-wrap', 'no-wrap', 'show');
    document.body.appendChild(clone);

    const items = Array.from(clone.children).filter((el) => el.tagName === 'LI');
    let wrapped = false;
    if (items.length > 1) {
        const firstTop = items[0].offsetTop;
        wrapped = items.some((li) => li.offsetTop !== firstTop);
    }

    document.body.removeChild(clone);
    return wrapped;
}

// Helper: desktop breakpoint guard (keeps in sync with enquire rule 890px)
function isDesktopViewport() {
    return (window.matchMedia ? window.matchMedia('(min-width: 890px)').matches : (window.innerWidth >= 890));
}

// Recalculate on resize (debounced)
let __level1ResizeTO;
window.addEventListener('resize', () => {
    clearTimeout(__level1ResizeTO);
    __level1ResizeTO = setTimeout(adjustAllVisibleLevel1, 100);
});

document.addEventListener('show.bs.dropdown', (e) => {
    const dropdown = e.target; // li.dropdown
    const level1 = dropdown && dropdown.querySelector
        ? dropdown.querySelector('ul.dropdown-menu.level-1')
        : null;
    adjustLevel1Justify(level1);
});

// Correct any misclassification AFTER it becomes visible (uses actual rendered width)
document.addEventListener('shown.bs.dropdown', (e) => {
    const dropdown = e.target;
    const level1 = dropdown && dropdown.querySelector
        ? dropdown.querySelector('ul.dropdown-menu.level-1')
        : null;
    if (!level1 || !isDesktopViewport()) return;

    const visibleWidth = Math.max(0, Math.floor(level1.getBoundingClientRect().width || 0));
    const wrapped = measureWrapForLevel1(level1, visibleWidth);
    level1.classList.toggle('has-wrap', wrapped);
    level1.classList.toggle('no-wrap', !wrapped);
});

/*
* Contact Form 7: Hinweis beim Klick auf den deaktivierten Senden-Button.
*
* Ist die CF7-Option "acceptance_as_validation" aktiv, deaktiviert CF7 den
* Senden-Button, solange die Datenschutz-Checkbox nicht gesetzt ist. Ein nativer
* disabled-Button feuert aber keine Klick-Events - der Nutzer klickt also ins
* Leere ohne Rueckmeldung. Wir setzen den deaktivierten Button per CSS auf
* pointer-events:none (siehe _contact-form-7.scss), damit der Klick den Formular-
* Container erreicht, pruefen die Klickposition gegen den Button und blenden dann
* einen Hinweis ein. Sobald das Haekchen gesetzt (Button aktiv) ist, verschwindet er.
*/
function contactFormSubmitHint() {
    document.querySelectorAll('.wpcf7-form').forEach(function (form) {
        const submit = form.querySelector('.wpcf7-submit');
        if (!submit) return;

        // Hinweis-Element einmalig unter der Datenschutz-Checkbox anlegen, damit er
        // an derselben Stelle wie die uebrigen CF7-Meldungen (.wpcf7-not-valid-tip)
        // erscheint. Als span (display:block via CSS), passend zum Wrap der Checkbox.
        let hint = form.querySelector('.wpcf7-submit-hint');
        if (!hint) {
            hint = document.createElement('span');
            hint.className = 'wpcf7-submit-hint';
            hint.setAttribute('role', 'alert');
            hint.hidden = true;
            hint.textContent = 'Bitte bestätigen Sie zunächst die Datenschutzerklärung, um das Formular absenden zu können.';

            const acceptance = form.querySelector('.wpcf7-acceptance');
            const anchor = (acceptance && acceptance.closest('.wpcf7-form-control-wrap')) || acceptance;
            if (anchor) {
                anchor.appendChild(hint);
            } else {
                // Fallback: unter dem Button, falls kein Acceptance-Feld gefunden wird.
                const wrapper = submit.closest('p') || submit.parentNode;
                wrapper.parentNode.insertBefore(hint, wrapper.nextSibling);
            }
        }

        // Klick auf den (per CSS durchlaessig gemachten) deaktivierten Button abfangen.
        form.addEventListener('click', function (event) {
            if (!submit.disabled) {
                hint.hidden = true;
                return;
            }
            const rect = submit.getBoundingClientRect();
            const onButton = event.clientX >= rect.left && event.clientX <= rect.right &&
                event.clientY >= rect.top && event.clientY <= rect.bottom;
            if (onButton) {
                hint.hidden = false;
            }
        });

        // Wird das Haekchen gesetzt (Button aktiv), Hinweis wieder ausblenden.
        // CF7 aktualisiert submit.disabled in seinem eigenen change-Handler; wir
        // pruefen erst am Ende des Event-Ticks, damit die Listener-Reihenfolge egal ist.
        form.addEventListener('change', function () {
            setTimeout(function () {
                if (!submit.disabled) {
                    hint.hidden = true;
                }
            }, 0);
        });
    });
}

contactFormSubmitHint();


document.addEventListener('DOMContentLoaded', function() {
    // Sticky Header nur aktivieren, wenn im Customizer eingeschaltet (Body-Klasse via functions.php).
    if (!document.body.classList.contains('sticky-header-enabled')) return;

    const header = document.querySelector('header#wrapper-navbar'); // Selektor anpassen
    if (!header) return;

    const headerHeight = header.offsetHeight;
    const stickyOffset = header.offsetTop + headerHeight;

    window.addEventListener('scroll', function() {
        if (window.pageYOffset > stickyOffset) {
            header.classList.add('is-sticky');
            // Verhindert das "Springen" des Contents beim Fixieren
            document.body.style.paddingTop = headerHeight + 'px';
        } else {
            header.classList.remove('is-sticky');
            document.body.style.paddingTop = '0';
        }
    });
});